const pink = "#F4D4DF";
const yellow = "#FEAC58";
const white = "white";
const green = "#CFD689";
const black = "#0F0F0F";
const blue = "#91A8D2";

export { pink, yellow, white, green, black, blue };